<template>
    <div>
        <b-row>
            <b-col>
                <b-button @click="openModalComponentForCreation"
                          variant="primary"
                          class="float-right"
                          size="sm"
                >
                    <i class="fa fa-plus"></i> Agregar
                </b-button>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col>
                <b-table responsive
                         hover
                         striped
                         thead-class="table-active"
                         show-empty
                         small
                         empty-text="No hay componentes para mostrar"
                         :items="raw_material.raw_material.components_product"
                         :fields="columns"
                >
                    <template v-slot:cell(reported_percentage)="data">
                        <input_formatter v-model="data.item.reported_percentage"
                                         symbol="%"
                                         :position_symbol="false"
                                         :decimals="4"
                                         input_class="text-center"
                                         @changeInput="_updateComponentProduct(data.item)"
                        />
                    </template>

                    <template v-slot:cell(final_percentage)="data">
                        {{ data.item.final_percentage || 0 }}%
                    </template>

                    <template v-slot:cell(omit_in_composition)="data">
                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Omitir en la composición"
                                    popper-class="py-1 px-2"
                        >
                            <div class="text-center">
                                <b-form-checkbox v-model="data.item.omit_in_composition"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(data.item)"
                                />
                            </div>
                        </el-tooltip>
                    </template>

                    <template v-slot:cell(omit_in_carcinogens)="data">
                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Omitir de cancerígenos"
                                    popper-class="py-1 px-2"
                        >
                            <div class="text-center">
                                <b-form-checkbox v-model="data.item.omit_in_carcinogens"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(data.item)"
                                />
                            </div>
                        </el-tooltip>
                    </template>

                    <template v-slot:cell(actions)="data">
                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Eliminar"
                                    popper-class="py-1 px-2"
                        >
                            <b-button variant="danger"
                                      class="float-right mr-1"
                                      size="sm"
                                      @click="_deleteComponent(data.item)"
                            >
                                <i class="fa fa-trash"/>
                            </b-button>
                        </el-tooltip>

                        <el-tooltip effect="dark"
                                    placement="top"
                                    content="Editar"
                                    popper-class="py-1 px-2"
                        >
                            <b-button variant="primary"
                                      class="float-right mr-1"
                                      size="sm"
                                      @click="openModalComponentForEdition(data.item)"
                            >
                                <i class="fa fa-edit"/>
                            </b-button>
                        </el-tooltip>
                    </template>
                </b-table>

            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12"
                   class="text-center"
            >
                <hr class="mt-0 mb-3">
                <b-button @click="setStepToModalWizard((modal_wizard.step - 1))"
                          variant="secondary"
                          class="float-left"
                          size="sm"
                >
                    <i class="fa fa-arrow-left"></i> Atrás
                </b-button>
                <b-button variant="primary"
                          class="float-right"
                          size="sm"
                          @click="end"
                >
                    Finalizar
                    <i class="fa fa-check"></i>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import Swal from 'sweetalert2';
import input_formatter from '../../../components/input_formatter.vue';

export default {
    name: 'components',
    components: {input_formatter},
    data() {
        return {
            name: '',
            columns: [
                {
                    key: 'component.cas_number',
                    label: 'No. CAS'
                },
                {
                    key: 'component.name',
                    label: 'Nombre'
                },
                {
                    key: 'reported_percentage',
                    label: '% Reportado',
                    thStyle: 'width: 100px; max-width: 100px;'
                },
                {
                    key: 'final_percentage',
                    label: '% Final',
                    tdClass: 'text-center'
                },
                {
                    key: 'omit_in_composition',
                    label: 'Composición'
                },
                {
                    key: 'omit_in_carcinogens',
                    label: 'Cancerígenos'
                },
                {
                    key: 'actions',
                    label: ''
                }
            ]
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'modal_components',
            'modal_wizard'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'updateComponentProduct',
            'deleteRawMaterial',
            'updateComponents',
            'getProduct',
            'deleteComponentProduct',
            'getRawMaterial'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentShow',
            'setModalComponentsShow',
            'setComponent',
            'deleteComponent',
            'setStepToModalWizard',
            'setShowToModalWizard',
            'addComponent',
            'resetComponent',
            'setComponent',
            'setModalComponentShow',
            'setActionComponent',
            'resetComponentProduct'
        ]),
        async _updateComponentProduct(component) {
            let reg = new RegExp('^(\\d{0,2}(\\.\\d{1,2})?|100(\\.00?)?)$');

            if (reg.test(component.reported_percentage.toString())) {
                await this.updateComponentProduct(component);
                await this.getRawMaterial(this.raw_material);
            }
        },
        openModalComponentForEdition(component) {
            this.setActionComponent('Editar');
            this.setShowToModalWizard(false);
            this.setModalComponentShow(true);
            this.setComponent(component.component);
        },
        openModalComponentForCreation() {
            this.resetComponentProduct();
            this.setShowToModalWizard(false);
            this.setModalComponentShow(true);
        },
        async _deleteComponent(component) {
            await Swal.fire({
                title: 'Eliminar',
                text: 'Esta seguro de eliminar el componente seleccionado?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si',
            }).then(async (result) => {
                if (result.value) {
                    await this.deleteComponentProduct(component);
                    await this.getRawMaterial(this.raw_material);
                }
            });
        },
        async end() {
            const product_id = this.$route.params.product_id;
            const company_id = this.$route.params.company_id;

            if (!!product_id && !!company_id) {
                await this.getProduct({product_id, company_id});
            }

            this.setShowToModalWizard(false);
        }
    }
};
</script>

<style scoped>

</style>
